import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService }      from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(
    private authService: AuthService, 
    private router: Router
  ) {}

  //The ActivatedRouteSnapshot contains the future route that will be activated and the RouterStateSnapshot contains
  //the future RouterState of the application, should you pass through the guard check.
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):  boolean{
      let url: string = state.url;

      return this.checkLogin(url);
  }

  /**
   * If the user is not logged in, you store the attempted URL the user came from using the
   *  RouterStateSnapshot.url and tell the router to navigate to a login page—a page you haven't created yet.
   * This secondary navigation automatically cancels the current navigation; checkLogin() returns false just to be clear about that.
  */
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      /*const allowedRoles = next.data.allowedRoles;
    const isAuthorized = this.authorizationService.isAuthorized(allowedRoles);

    if (!isAuthorized) {
      this.router.navigate(['accessdenied']);
    }
    */
    return this.canActivate(next,state);
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }


  checkLogin(url: string): boolean {
     


    // if (this.authService.isAuthenticated()) {
    //   //return true;
    //   if (url == "/company-settings"){
    //     return true;
    //   } else {

    //     false;
    //   }
    // }

    if (this.authService.isAuthenticated()) {
      
      return true;
    }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    this.router.navigate(['/Login']);
    return false;
  }

  /*
canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const allowedRoles = next.data.allowedRoles;
    const isAuthorized = this.authorizationService.isAuthorized(allowedRoles);

    if (!isAuthorized) {
      // if not authorized, show access denied message
      this.router.navigate(['/accessdenied']);
    }

    return isAuthorized;
  }
  */
}
